import { render } from "./InviteFriends.vue?vue&type=template&id=27e065c4&ts=true"
import script from "./InviteFriends.vue?vue&type=script&lang=ts"
export * from "./InviteFriends.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__